const es = {
    splash: {
        start: {
            helper: "Pulse el boton para comenzar",
            button: "Iniciar pedido"
        },
        banner: {
            title: "Bienvenido a {ORGANISATION}!",
            content: "Utilice este quiosco de autoservicio para pedir facilmente sus entrada(s)."
        }
    },
    catalog: {
        loading: "Cargando...",
        tabs: {
            ongoing: "Actuales",
            all: "Todo"
        },
        items: {
            select: "Seleccionar",
            empty: "No hay eventos proximos!"
        }
    },
    cart: {
        title: "Mi reserva",
        empty: "Todavia no hay entradas en su reserva!",
        items: {
            tickets: "Entradas",
            date: "Fecha",
            time: "Hora"
        },
        total: "Importe total",
        buttons: {
            checkout: "Pagar",
            cancel: "Cancelar"
        }
    },
    booking: {
        steps: {
            quantity: {
                title: "Cantidad de entradas"
            },
            upsell: {
                title: "Extras para su pedido"
            },
            plot: {
                title: "Reserva",
                empty: "No hay franjas de reserva disponibles.",
                now: "Ha seleccionado una franja para entrar ahora.",
                change: "Cambiar"
            }
        },
        buttons: {
            continue: "Continuar",
            return: "Volver",
            cancel: "Cancelar"
        }
    },
    checkout: {
        loading: "Cargando...",
        steps: {
            payment: "Complete el pago en el terminal de pago...",
            acts: {
                payment: "Complete el pago con tarjeta o en efectivo...",
                paymentLeft: "Todavia tiene que pagar {paymentLeft}",
                cancel: "Cancelar"
            },
            tickets: "Pago correcto! Retire sus entradas...",
            tickets_info: "Tambien desea recibir un recibo de pago?",
            receipt: "Retire su recibo...",
            receipt_info: "Su recibo de pago ha sido impreso.",
            failures: {
                transaction: {
                    title: "El pago no se ha completado!",
                    description: "Puede volver a intentar la transaccion."
                },
                print: {
                    title: "No se pudieron imprimir las entradas ni el recibo!",
                    description: "Pida a un empleado que revise la impresora. Sus entradas y el recibo se imprimiran despues."
                }
            },
            error: "No se pudo realizar el pedido!"
        },
        buttons: {
            retry: "Intentar de nuevo",
            cancel: "Volver",
            next: "Siguiente cliente",
            yes: "Si",
            yes_info: "Quiero un recibo!",
            no: "No",
            no_info: "No necesito recibo!",
            reprint_tickets: "Reimprimir entradas",
            reprint_tickets_countdown: "Reimprimir entradas ({seconds}s)"
        }
    },
    errors: {
        audience_not_found: "No se encontro el publico objetivo.",
        captcha_invalid: "El CAPTCHA no es valido. Recargue la pagina y vuelva a realizar el pedido.",
        coupon_expired: "Este cupon ha caducado.",
        coupon_invalid: "El codigo de cupon indicado no es valido.",
        coupon_product_mismatch: "Este cupon no se puede usar para este producto.",
        coupon_redemptions_exceeded: "Este cupon ya se ha utilizado por completo.",
        customer_field_invalid: "Un campo del formulario es incorrecto. Revise sus datos.",
        customer_field_missing: "Falta un campo del formulario. Revise sus datos.",
        customer_token_invalid: "La clave del cliente no es valida. Inicie sesion de nuevo.",
        customer_token_required: "Esta direccion de correo ya esta registrada. Inicie sesion antes de realizar un pedido.",
        plot_capacity_insufficient: "La franja que intenta reservar ya no tiene disponibilidad. Seleccione otra franja.",
        plot_not_found: "La franja que intenta reservar ya no esta disponible.",
        product_max_quantity_exceeded: "La cantidad de entradas supera el maximo permitido. Reduzca la cantidad.",
        product_min_quantity_exceeded: "La cantidad de entradas es inferior al minimo requerido. Aumente la cantidad.",
        product_not_found: "El producto que intenta pedir ya no esta disponible.",
        rebook_invalid: "La nueva reserva no es valida.",
        rebook_product_mismatch: "La nueva reserva no se puede usar con el producto indicado.",
        subscription_expired: "La suscripcion ha caducado.",
        subscription_inactive: "La suscripcion ya no esta activa. Probablemente no haya capacidad disponible.",
        subscription_invalid: "La suscripcion no es valida.",
        subscription_not_found: "No se pudo encontrar la suscripcion indicada.",
        subscription_product_mismatch: "La suscripcion no da acceso a este producto.",
        subscription_quantity_mismatch: "La suscripcion no da acceso a estas cantidades.",
        subscription_redemptions_exceeded: "La suscripcion ha superado su uso maximo.",
        subscription_used_today: "La suscripcion ya se ha utilizado hoy.",
        upsell_not_allowed: "Este extra no se puede pedir junto con este producto.",
        upsell_not_found: "No se encontro el extra."
    },
    printer: {
        title: "Se produjo un error en la impresora!",
        reload: "Intentar de nuevo",
        errors: {
            paper_empty: "Queda poco papel.",
            cover_open: "La tapa esta abierta.",
            device_offline: "No se puede establecer la conexion.",
            device_malfunction: "Se produjo un error general."
        }
    }
};

export default es;
